<style type="text/css">
  #con::after{
    content: '';
    background-color: rgba(5, 180, 249, .9);
    z-index:-1;

  }

  @media (max-width: 468px) {
    img{
      height: 100px;
    }
  }

</style>
<template>
  <v-content id="con" style="background-image: url('assets/hero2.jpg');background-position: center center;background-repeat: no-repeat;background-attachment: fixed;background-size: cover;background-color: #464646;">
    <section >
      <v-parallax >
        <v-layout
            column
            align-center
            justify-center
            class="white--text"
        >
          <img src="assets/logo_caja.png" alt="Vuetify.js" height="170">
          <div class="black--text title mt-2 mb-4 text-xs-center">Reserva web de citas</div>
          <router-link :to="{name: 'ingreso'}" tag="button">
            <v-btn class="blue lighten-2 mt-2" dark large>Comenzar</v-btn>
          </router-link>
          <router-link :to="{name: 'teyuna'}" tag="button">
              <v-btn class="orange lighten-2 mt-2" dark large>Reservar Teyuna</v-btn>
            </router-link>
          <router-link :to="{name: 'kits'}" tag="button">
            <v-btn class="green lighten-2 mt-2" dark large>Solicitar Cita Kit/Bono</v-btn>
          </router-link>
            <router-link :to="{name: 'cuotas'}" tag="button">
              <v-btn class="indigo darken-4 lighten-2 mt-2" dark large>Cuotas Subsidio Proximas a Prescribir</v-btn>
            </router-link>

            <router-link :to="{name: 'nuevo_medio'}" tag="button">
              <v-btn class="darken-4 lighten-2 mt-2" dark large>Cita para Medios de pagos Primera Vez</v-btn>
            </router-link>

        </v-layout>
      </v-parallax>
    </section>
  </v-content>
</template>

<script>
  export default {
    data() {
      return {
        title: 'Your Logo'
      }
    },
  }
</script>



// WEBPACK FOOTER //
// src/components/Portada.vue